import { useState } from 'react'
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Fade from '@mui/material/Fade'
import Grid from '@mui/material/Grid'
import { useAuth, useQuery } from '../App'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import { InputAdornment } from '@mui/material'
import backgroundLog from '../assets/backlog.svg'
import { useTranslation } from 'react-i18next'

const Reset = () => {
  const [password, setPassword] = useState('')
  const [passwordConfirm, setPasswordConfirm] = useState('')
  const auth = useAuth()
  const query = useQuery()
  const { t } = useTranslation()
  return (
    <Fade in timeout={300}>
    <Grid
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
      sx={{
        backgroundAttachment: 'fixed',
        backgroundImage: `url(${backgroundLog})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundColor: 'transparent',
        minHeight: '100vh'
      }}
    >
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Grid container justifyContent="center" alignItems="center">
          <Grid
            xs={12}
            sm={12}
            md={12}
            lg={12}
            item
            sx={{
              maxWidth: '512px',
              backdropFilter: 'blur(4px)',
              borderRadius: 4,
              padding: 2,
              margin: 2,
              color: (theme) =>
                theme.palette.mode === 'dark'
                  ? '#f8f8f8'
                  : 'rgba(0, 0, 0, 0.54)',
              backgroundColor: 'background.default'
            }}
          >
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="stretch"
                sx={{ padding: 1 }}
              >
                <Grid item sx={{ marginTop: 6, marginBottom: 6 }}>
                  <Grid
                    container
                    direction="column"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box fontSize="caption.fontSize" textAlign="center">
                      {t('reset.title', 'Reset your password')}
                    </Box>

                    <Box
                      fontWeight="fontWeightBold"
                      fontSize="h6.fontSize"
                      textAlign="center"
                    >
                      {t('reset.subtitle', 'Enter your new password')}
                    </Box>
                  </Grid>
                </Grid>
                <Box component="form" noValidate autoComplete="off">
                  <TextField
                    fullWidth
                    name="password"
                    type="password"
                    sx={{ marginBottom: 1, marginTop: 1 }}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="********"
                    label={t('reset.newPassword', 'New password')}
                    InputProps={{
                      sx: { borderRadius: 2 },
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockOpenIcon />
                        </InputAdornment>
                      )
                    }}
                  />
                  <TextField
                    fullWidth
                    name="password"
                    label={t('reset.confirmation', 'Confirmation')}
                    type="password"
                    sx={{ marginBottom: 1, marginTop: 1 }}
                    value={passwordConfirm}
                    onChange={(e) => setPasswordConfirm(e.target.value)}
                    placeholder="********"
                    InputProps={{
                      sx: { borderRadius: 2 },
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockOpenIcon />
                        </InputAdornment>
                      )
                    }}
                  />
                  <Grid item sx={{ marginBottom: 2, marginTop: 2 }}>
                    <Button
                      sx={{
                        minHeight: 48,
                        borderRadius: 4,
                      }}
                      fullWidth
                      size="large"
                      onClick={() =>
                        auth?.resetPass(query.get('oobCode'), password)
                      }
                      variant="contained"
                    >
                      {t('reset.submit', 'Reset')}
                    </Button>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
    </Fade>
  )
}
export default Reset
